export default __webpack_public_path__ + "images/RA.71a7ccb.png";